import script from "./OperatorApplicationCobrowse.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationCobrowse.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationCobrowse.vue?vue&type=style&index=0&id=5793005e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5793005e"]])

export default __exports__